import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import StatusInfoCard from "./StatusInfoCard";
import { useEnumApi } from "contexts/EnumApiContext";
import { equipmentFaultStatusColors } from "data/data";

const DiagnosisCard = ({ info }) => { 
    const { t } = useTranslation();
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    if (!info) return null;
    
    const getFontSize = (text) => {
        if (text.length <= 2) return 26;
        if (text.length <= 4) return 20;
        if (text.length <= 6) return 17;
        return 14;
    };

    const statusName = getEnumValueByEnumNameAndCode('EquipmentFaultStatus', info?.status)?.[0]?.title || '-';
    const statusInfo = equipmentFaultStatusColors.find(data => data.code === info?.status);

    return (
    <StatusInfoCard title={t('message.common.subtitle.diagnosis.info')} cardType="charts_circle">
        <Box
            sx={{
                borderRadius: 2,
                p: 1.5,
                boxSizing: "border-box",
                fontSize: info?.status !== 'O1_N' ? "20px":"inherit"
            }}
        >
            <svg width="100" height="100" viewBox="0 0 100 100">
                <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill={`${statusInfo?.color ?? "#bbbbbb"}`}
                />
                <text
                    x="50"
                    y="50"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill={`${statusInfo?.fontColor ?? "#fff"}`}
                    fontSize={getFontSize(statusName)}
                    fontWeight="bold"
                >
                    {statusName}
                </text>
            </svg>
        </Box>
    </StatusInfoCard>
    );
}

export default DiagnosisCard;